import { render, staticRenderFns } from "./DialogoBuscarServicos.vue?vue&type=template&id=1bff0864&scoped=true&"
import script from "./DialogoBuscarServicos.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff0864",
  null
  
)

export default component.exports